import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37d2a31d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-main" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "vip-tip"
}
const _hoisted_4 = {
  key: 1,
  class: "cur"
}

import { ref, computed, onMounted, onBeforeMount } from "vue";
import { queryExampaperList } from '@/api/index'

export default /*#__PURE__*/_defineComponent({
  __name: 'tabList',
  props: {
    // 试卷列表
    data: {
        type: Array,
        default: () => [],
    },
    defaultValue:{
        type:Number,
        default: () => 1
    }
},
  emits: ['tabClick'],
  setup(__props, { emit: $emit }) {

const props = __props;




let defaultCur = computed(()=> props.defaultValue)
const tabClick = (data) => {
    console.log(data)
    // curSelect.value = data.value
    $emit('tabClick',data)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "tab-item",
        key: index,
        onClick: ($event: any) => (tabClick(item))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["title", item.value === _unref(defaultCur) ? 'curClass' : 'defaultClass' ])
        }, _toDisplayString(item?.title), 3),
        (index !== 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3))
          : _createCommentVNode("", true),
        (item.value === _unref(defaultCur))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4))
          : _createCommentVNode("", true)
      ], 8, _hoisted_2))
    }), 128))
  ]))
}
}

})